import { InfoButton, Inline, Stack, Text, Tooltip } from '@etg/wings';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { ScreenReaderPrice } from '@eti/components';
import { CABIN_BAGGAGE, CHECK_IN_BAGGAGE } from '../../../products';
import { getMarkupPerBound, getPricePerBound } from '../utils/priceUtil';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const priceInfoRowStyles = css`
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
`;
const priceStyles = css`
  align-items: flex-end;
  display: flex;
`;
const BaggagePriceBreakdownTooltip = _ref => {
  let {
    'data-testid': dataTestId,
    markup,
    numberOfBounds,
    priceRaw,
    productId,
    showPricePerBound
  } = _ref;
  const {
    t
  } = useTranslation();
  const isCabinBaggage = productId === CABIN_BAGGAGE.id;
  const isCheckedBaggage = productId === CHECK_IN_BAGGAGE.id;
  const providerCostLabelCabinBaggage = t('Product.CabinBaggagePerTraveler.ProviderCost.Label');
  const providerCostLabelCheckedBaggage = t('Product.CheckedBaggage.ProviderCost.Label');
  const markupLabel = t('Product.CabinAndCheckedBaggage.Markup.Label');
  const ariaLabel = t('ScreenReader.PriceSpecification.InfoButton');
  const providerCostLabel = () => {
    if (isCabinBaggage) {
      return providerCostLabelCabinBaggage;
    }
    if (isCheckedBaggage) {
      return providerCostLabelCheckedBaggage;
    }
    return '';
  };
  const totalPrice = getPricePerBound({
    numberOfBounds,
    priceRaw,
    showPricePerBound
  });
  const markupFee = getMarkupPerBound({
    markup,
    numberOfBounds,
    showPricePerBound
  });
  const providerCost = totalPrice - markupFee;
  return /*#__PURE__*/_jsx(Tooltip, {
    content: /*#__PURE__*/_jsxs(Stack, {
      spacing: 8,
      children: [/*#__PURE__*/_jsxs(Inline, {
        className: priceInfoRowStyles,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          "data-testid": `${dataTestId}-tooltip-provider-cost-label`,
          children: providerCostLabel()
        }), /*#__PURE__*/_jsx(Text, {
          "aria-hidden": "true",
          className: priceStyles,
          "data-testid": `${dataTestId}-tooltip-provider-cost`,
          children: priceUtils.formatPrice(providerCost)
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: priceUtils.formatPrice(providerCost)
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        className: priceInfoRowStyles,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          "data-testid": `${dataTestId}-tooltip-markup-label`,
          children: markupLabel
        }), /*#__PURE__*/_jsx(Text, {
          "aria-hidden": "true",
          className: priceStyles,
          "data-testid": `${dataTestId}-tooltip-markup-fee`,
          children: priceUtils.formatPrice(markupFee)
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: priceUtils.formatPrice(markupFee)
        })]
      })]
    }),
    "data-testid": `baggage-tooltip-product-${productId}`,
    title: "",
    children: /*#__PURE__*/_jsx(InfoButton, {
      "data-testid": `${dataTestId}-info-button`,
      label: ariaLabel
    })
  });
};
export default BaggagePriceBreakdownTooltip;
//# sourceMappingURL=BaggagePriceBreakdownTooltip.js.map